import * as Sentry from '@sentry/react';

import { isDev } from '~/dev/utils/isDev';

interface SubmitAppCrashFeedbackParams {
  message: string;
  /** Crash event the report belongs to, so it lands on the same stack trace. */
  eventId?: string;
}

/**
 * Unlike the other feedback helpers this one sends no name or email: the crash
 * screen deliberately reads no Redux state (a broken store is a plausible cause
 * of the crash), and `Sentry.setUser` has already put the person on the scope.
 */
export const submitAppCrashFeedback = ({
  message,
  eventId,
}: SubmitAppCrashFeedbackParams) => {
  if (isDev) {
    console.info('[app-crash feedback]', { message, eventId });
    return;
  }

  Sentry.captureFeedback(
    {
      message,
      associatedEventId: eventId,
      url: window.location.href,
      source: 'app-crash',
    },
    {
      includeReplay: true,
      captureContext: {
        tags: {
          feedback_type: 'app-crash',
        },
      },
    },
  );
};
